import { Navigate, Outlet } from "react-router-dom";
import { getRequest } from "../../config/axiosConfig";
import { useEffect, useState } from "react";
import Loader from "../loader/loader";

export const ProtectEmployeeRoute = () => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const checkEmployeeAuth = async () => {
      try {
        const res = await getRequest({
          url: process.env.REACT_APP_BASE_URL + "auth/employee/me-employee",
        });

        if (res?.success) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.log(error);
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    checkEmployeeAuth();
  }, []);

  useEffect(() => {
    console.log("isAuthenticated", isAuthenticated);
  }, [isAuthenticated]);

  if (loading) return <Loader />;

  if (!isAuthenticated) {
    return <Navigate to="/employee-login" replace />;
  }

  return <Outlet />;
};
